import { Renderer } from "./Renderer/Renderer";
/**
 * 舞台对象
 */
var Stage = /** @class */ (function () {
    function Stage(_a) {
        var container = _a.container, size = _a.size, perspective = _a.perspective, getTime = _a.getTime;
        this.container = container;
        this.size = size || [1920, 1080];
        this.perspective = perspective || this.size[0];
        this.scale = 1;
        this.getTime = getTime;
        // 创建舞台
        this.el = document.createElement("div");
        this.el.classList.add("pos-danmaku-stage");
        this.el.style.width = this.size[0] + "px";
        this.el.style.height = this.size[1] + "px";
        this.el.style.position = "absolute";
        this.el.style.transformOrigin = "left top";
        this.el.style.transformStyle = "preserve-3d"; // 启用3D效果
        this.el.style.perspective = this.perspective + "px"; // 视点与弹幕舞台距离
        this.container.appendChild(this.el);
        this.resize();
        this.stylesheet = document.createElement("style");
        this.stylesheet.innerText += ".pos-danmaku-stage.paused .pos-danmaku-item { animation-play-state: paused }";
        this.stylesheet.innerText += ".pos-danmaku-item.pos-danmaku-invisible { visibility: hidden }";
        this.stylesheet.innerText += ".pos-danmaku-item-content { -webkit-text-size-adjust: none; text-size-adjust: none}";
        this.container.appendChild(this.stylesheet);
        this.renderer = new Renderer(this.size);
        this.pause(); // 实例创建后设为暂停状态
    }
    /** 从列表中添加弹幕 */
    Stage.prototype.addFromList = function (list) {
        var _this = this;
        list.forEach(function (dan) {
            _this.add(dan);
        });
    };
    /** 添加一条弹幕 */
    Stage.prototype.add = function (dan) {
        var _this = this;
        // 检测弹幕是否早已结束
        if (dan.end > this.getTime()) {
            // 获得一条完整的弹幕
            var danmakuElement_1 = this.renderer.render(dan);
            // 添加开始前隐藏机制
            danmakuElement_1.classList.add("pos-danmaku-invisible");
            danmakuElement_1.addEventListener("animationstart", function () {
                danmakuElement_1.classList.remove("pos-danmaku-invisible");
            }, { once: true });
            // 添加结束后销毁机制
            danmakuElement_1.addEventListener("animationend", function (e) {
                if (e.animationName.substring(e.animationName.length - 1) == "E") {
                    _this.el.removeChild(danmakuElement_1);
                }
            });
            // 根据当前时间设定动画延迟
            danmakuElement_1.style.animationDelay = this.renderer.animationRenderer.getCssAnimationDelay(dan.danmaku, dan.start - this.getTime());
            // 挂载
            this.mount(danmakuElement_1);
            return danmakuElement_1;
        }
        else {
            console.log("\u5F39\u5E55\u5DF2\u7ED3\u675F: id-".concat(dan.id, " ").concat(dan.end, " < ").concat(this.getTime()));
        }
    };
    /** 将弹幕DOM元素挂载到舞台上 */
    Stage.prototype.mount = function (danElement) {
        this.el.appendChild(danElement);
    };
    /** 根据id删除弹幕元素 */
    Stage.prototype.remove_id = function (id) {
        var element = this.el.querySelector("[data-id=".concat(id, "]"));
        element && this.el.removeChild(element);
    };
    /** 根据rid删除弹幕元素 */
    Stage.prototype.remove_rid = function (rid) {
        var element = this.el.querySelector(".pos-danmaku-item-".concat(rid));
        element && this.el.removeChild(element);
    };
    /** 清屏 */
    Stage.prototype.clear = function () {
        this.el.innerHTML = "";
    };
    /** 播放 */
    Stage.prototype.play = function () {
        this.el.classList.remove("paused");
    };
    /** 暂停 */
    Stage.prototype.pause = function () {
        this.el.classList.add("paused");
    };
    Stage.prototype.resize = function () {
        var _a = this.container.getBoundingClientRect(), width = _a.width, height = _a.height;
        if (width / this.size[0] < height / this.size[1]) { // 宽占满
            this.scale = width / this.size[0];
            this.el.style.transform = "scale(".concat(width / this.size[0], ", ").concat(width / this.size[0], ")");
            this.el.style.left = "0px";
            this.el.style.top = (height - this.size[1] * this.scale) / 2 + "px";
        }
        else { // 高占满
            this.scale = height / this.size[1];
            this.el.style.transform = "scale(".concat(height / this.size[1], ", ").concat(height / this.size[1], ")");
            this.el.style.left = (width - this.size[0] * this.scale) / 2 + "px";
            this.el.style.top = "0px";
        }
    };
    return Stage;
}());
export { Stage };
//# sourceMappingURL=Stage.js.map